import { makeStyles } from "@material-ui/core/styles";
import { Colors } from "constants/constants";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
    gap: "10px",
    borderBottom: "none",
  },
  paper: {
    background: "#F9FAFA",
    boxShadow: "none",
    padding: theme.spacing(3, 2),
  },
  filters: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  filtersLeft: {
    display: "flex",
    gap: theme.spacing(2),
  },
  filterTextBox: {
    padding: theme.spacing(2),
    background: "#F9FAFA",
  },
  filterText: {
    fontWeight: 500,
  },
  body: {
    padding: theme.spacing(0, 2),
  },
  stationFilterBox: {
    display: "flex",
  },
  stationOption: {
    cursor: "pointer",
    transition: "0.3s",
    padding: "8px 16px 6px",
    borderBottom: "2px solid #bebfc000",
  },
  activeStationOption: {
    color: "#0129FA",
    background: "white",
    borderBottom: "2px solid #0129FA",
  },
  tableContainer: {
    maxHeight: "70vh",
  },
  tableRow: {
    background: "#F9FAFA",
  },
  tableCell: {
    position: "relative",
    borderBottom: "1px solid #BEBFC0",
    maxWidth: 180,
    padding: "22px 0px",
  },
  tableHeadCell: {
    borderBottom: "2px solid #BEBFC0",
    minWidth: 72,
    padding: "12px 0px",
    background: "#F9FAFA",
  },
  tablePlanCell: {
    maxWidth: 120,
    borderBottom: "1px solid #BEBFC0",
    minWidth: 120,
    padding: "14px 0px",
  },
  tableCollapseCell: {
    position: "relative",
    borderBottom: "1px solid #BEBFC0",
    maxWidth: 180,
    padding: "22px 0px",
  },
  tableCellContent: {
    paddingLeft: 14,
    paddingRight: 14,
  },
  tableContentButtons: {
    display: "flex",
    gap: theme.spacing(1),
  },
  tableBottomCellContent: {
    paddingLeft: 6,
    paddingRight: 6,
  },
  editField: {
    width: 84,
    maxWidth: 84,
  },
  sizeCell: {
    width: 110,
    maxWidth: 110,
  },
  borderCellRightLight: {
    borderRight: "1px solid #E0E0E0",
  },
  borderCellRightDark: {
    borderRight: "1px solid #BEBFC0",
  },
  borderCellTopThink: {
    borderTop: "2px solid #BEBFC0",
  },
  borderCellBottomThick: {
    borderBottom: "2px solid #BEBFC0",
  },
  labelBox: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontSize: 12,
    fontWeight: 400,
    textTransform: "uppercase",
  },
  mainLabel: {
    fontWeight: 600,
  },
  collapseRow: {
    background: "#F9FAFA",
    transition: "0.3s",
  },
  activeCollapseRow: {
    background: "#EAECEC",
  },
  collapseBtn: {
    color: "#0E1011",
    transition: "0.3s",
  },
  activeCollapseBtn: {
    rotate: "180deg",
  },
  collapseLabelBox: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1),
  },
  collapseLabel: {
    whiteSpace: "nowrap",
    fontWeight: 600,
  },
  thickBorderCellBottom: {
    borderBottom: "2px solid #BEBFC0",
  },
  activeRow: {
    background:"#0129FA1A",
  },
  planEditBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
  },
  //Correction table
  correctionTableSection: {
    marginTop: theme.spacing(4),
    border: "#BEBFC0 1px solid",
  },
  correctionTableContainer: {
    maxHeight: 374,
  },
  tableBody: {
    "& tr:last-child td, & tr:last-child th": { borderBottom: 0 },
  },
  correctionTableHeadCell: {
    padding: "16px 0",
    borderBottom: "#BEBFC0 1px solid",
    background: Colors.WHITE,
  },
  tableCellButtons: {
    display: "flex",
    gap: theme.spacing(1),
  },
  addRow: {
    transition: "0.3s",
    background: Colors.WHITE,
    boxSizing: "border-box",
    width: "100%",
    cursor: "pointer",
    padding: "22px 18px",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    borderTop: "#BEBFC0 1px solid",
    "&:hover": {
      background: "#EAECEC",
    },
  },
  textareaSection: {
    width: "100%",
    marginTop: theme.spacing(4),
  },
  textareaLabel: {
    fontSize: 12,
    fontWeight: 400,
  },
  textarea: {
    height: 160,
    marginTop: theme.spacing(0.5),
    display: "flex",
    alignItems: "flex-start",
  },
  editedMessage: {
    color: "#5F6164",
    fontWeight: 400,
  },
  actionSection: {
    padding: theme.spacing(2, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: theme.spacing(2),
  },
  actionButtons: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    marginLeft: "0 !important",
    gap: theme.spacing(1),
  },
  drawerButton: {},
  hiddenElem: {
    visibility: "hidden",
  },
  redTheme: {
    background: "#C42020",
    "&:hover": {
      background: "#881414",
    },
  },
  popperPaper: {
    width: 440,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 24px",
  },
  "@media (max-width: 840px)": {
    filters: {
      flexDirection: "column",
      gap: theme.spacing(2),
    },
    filtersLeft: {
      width: "100%",
    },
    matchSection: {
      flexDirection: "column",
      alignItems: "start",
      gap: theme.spacing(2),
    },
    drawerButton: {
      width: "50%",
    },
    popperPaper: {
      width: 300,
    }
  },
}));
